module.exports = __webpack_public_path__ + "static/img/banner4.5569745.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/banner4.jpg
// module id = /xBw
// module chunks = 0